import * as React from 'react';
import { Engine } from '@websky/core';
import { ThemeProvider } from '@websky/core/src/theme';
import { RenderersProvider } from '@websky/core/src/renderProps';

import theme from '../../theme/theme';
import '../../theme/variables.css';
import engineRenderers from '../../renderProps';
import Head from '@websky/core/src/Head';
import LeavePageModal from '../LeavePageModal/LeavePageModal';

const EngineComponent: React.FC = () => {
	return (
		<ThemeProvider value={theme}>
			<RenderersProvider value={engineRenderers}>
				<Head />
				<Engine after={<LeavePageModal />} />
			</RenderersProvider>
		</ThemeProvider>
	);
};

export default EngineComponent;
